var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('b-col',{staticClass:"text-left text-middle font24pt"},[_vm._v("\n            "+_vm._s(_vm.total)+"\n        ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02646d95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StateTotal.vue
// module id = X07V
// module chunks = 1